import { ADICIONAR_FILTRO_ROTA_ITINERARIO, LIMPAR_FILTRO_ROTA_ITINERARIO, LISTAR_FILTROS_ROTA_ITINERARIO, REMOVER_FILTRO_ROTA_ITINERARIO } from '../../actions/types'
import { filtroExiste } from '../../util/filtros'

const initialState = undefined

const initial = {}

export const filtrosAdicionadosRotaItinerario = (state = [], action = initialState) => {
  switch (action.type) {
    case ADICIONAR_FILTRO_ROTA_ITINERARIO: {
      if (!filtroExiste(state, action.payload)) {
        return state.concat(action.payload)
      }
      return state
    }

    case REMOVER_FILTRO_ROTA_ITINERARIO: {
      const copia = [...state]
      return copia.filter(filtro => filtro.chave !== action.payload.chave || filtro.valor !== action.payload.valor)
    }

    case LIMPAR_FILTRO_ROTA_ITINERARIO: {
      return []
    }

    default:
      return state
  }
}

export const filtrosRotasItinerario = (state = initial, action) => {
  switch (action.type) {
    case LISTAR_FILTROS_ROTA_ITINERARIO: {
      return action.payload.data
    }
    default:
      return state
  }
}
